import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { FindhelpAttributeTag } from '@src/api.types';
import { prettyTextToKebabCase } from '@repo/utils';
import React from 'react';

export type FilterGroup = {
  id: string;
  heading: string;
  options: string[];
};

export type CboSearchFiltersPanelProps = {
  availableFilters: FilterGroup[];
  activeFilters: string[];
  setActiveFilters: (filters: string[]) => void;
  sortBy: 'relevance' | 'distance';
  setSortBy: (sortBy: 'relevance' | 'distance') => void;
};

// Filters that we don't want to include in the panel.
const excludeFilterHeadings = [
  'General',
  'Role',
  'AISD Locations',
  'Disaster Victims',
];

export function intoFilterSection(
  f: FindhelpAttributeTag
): FilterGroup | undefined {
  if (
    !f.children ||
    f.children.length === 0 ||
    excludeFilterHeadings.includes(f.title)
  ) {
    return undefined;
  }
  return {
    id: f.id,
    heading: f.title,
    options: f.children
      ?.filter((c) => c.filtersAvailable === true)
      .map((c) => c.title),
  };
}

export function CboSearchFiltersPanel({
  availableFilters,

  activeFilters,
  setActiveFilters,

  sortBy,
  setSortBy,
}: CboSearchFiltersPanelProps): React.JSX.Element {
  const currentlyChecked = activeFilters.map((active) =>
    active.toLocaleLowerCase()
  );

  function onCheckboxChange(event: any, option: string) {
    if (event.target.checked) {
      setActiveFilters([...activeFilters, option]);
    } else {
      setActiveFilters(activeFilters.filter((f) => f !== option));
    }
  }

  return (
    <div data-cy="cbo-search-filters-panel-container">
      <Heading size="sm" level={6}>Filters</Heading>

      <SelectInput
        label="Sort by"
        options={[
          { value: 'relevance', label: 'Relevance' },
          { value: 'distance', label: 'Distance' },
        ]}
        value={sortBy}
        onChange={(value) => {
          setSortBy(value as 'relevance' | 'distance');
        }}
      />

      {availableFilters.map((filter) => {
        return (
          <div
            style={{
              paddingTop: 4,
              paddingBottom: 4,
            }}
          >
            <label
              style={{
                paddingTop: 4,
                paddingBottom: 4,
              }}
            >
              {filter.heading}
            </label>
            {filter.options.map((option) => {
              return (
                <Checkbox
                  data-cy={`filter-checkbox-${prettyTextToKebabCase(option)}`}
                  label={option}
                  value={option}
                  isChecked={currentlyChecked.includes(
                    option.toLocaleLowerCase()
                  )}
                  onChange={(event) => {
                    onCheckboxChange(event, option);
                  }}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
